import Navbar from '../../../components/Navbar'
import Footer from '../../Home/components/Footer'
import { connect } from 'react-redux'
import setRedirectUrl from '../../../redux/actions/redirection/setRedirectUrl'
import setLogged from '../../../redux/actions/logged/setLogged'
import { useMediaQuery, useTheme } from '@mui/material'
import { Header } from '../../Galerias'
import FiltrosImagenes, { FiltrosIMG } from './FiltrosImagenes'
import { useCallback, useContext, useEffect, useState } from 'react'
import { TenantsContext } from '../../../context/tenants.context'
import { FotosProducto, IProducto } from '../types/producto'
import SnackBarUtils from '../../../utils/SnackBarUtils'
import ConfirmDialog from '../../Products/components/ConfirmDialog'
import FotosMobile from './FotosMobile'
import FotosDesktop from './FotosDesktop'
import { deleteCaptions, getImagenes, sincronizar } from '../services/productos.img.service'
import { defaultPaginatorRes, PaginatorRes } from '../../Pedidos/context/pedidos.context'
import { INITIAL_ROWS_PER_PAGE } from '../../Products/components/TableDataPagination'

export const modelos = [
  { name: 'Haiku', value: 'haiku' },
  { name: 'Nova', value: 'nova' }
]

const defaultFiltros: FiltrosIMG = {
  pagina: 1,
  pageSize: INITIAL_ROWS_PER_PAGE,
  codRubro: null,
  codLocal: null,
  nombreLocal: null,
  nombreProducto: null,
  estado: null,
  publicadoDesde: null,
  publicadoHasta: null,
  soloActivos: false,
  nombreRubro: null,
  idFoto: null,
  idProducto: null
}

const AdminProductosImagenes = (props: any) => {
  const [filtros, setFiltros] = useState<FiltrosIMG>(defaultFiltros)
  const [modelo, setModelo] = useState<string>(modelos[0].value)
  const [loading, setLoading] = useState<boolean>(false)
  const [loadingButtons, setLoadingButtons] = useState<Record<string, boolean>>({})
  const [paginator, setPaginator] = useState<PaginatorRes>(defaultPaginatorRes)
  const [searching, setSearching] = useState<boolean>(false)
  const [productos, setProductos] = useState<IProducto[]>(null)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const { tenant } = useContext(TenantsContext)
  const [confirmDialog, setConfirmDialog] = useState<any>({
    open: false,
    text: {
      title: '',
      body: '',
      leftButton: 'Cancelar',
      rightButton: 'Confirmar',
      colorButtonConfirm: 'primary'
    },
    action: async () => {}
  })

  const clearConfirmDialog = () => {
    setConfirmDialog((confirmDialog: any) => ({
      ...confirmDialog,
      open: false
    }))
  }

  // Paginator
  paginator.handleChangePage = (e: any, newPage: number) => {
    setFiltros((filtros) => ({
      ...filtros,
      pagina: newPage + 1
    }))
    setSearching(true)
  }

  paginator.handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const newPageSize = parseInt(event.target.value, 10)
    setFiltros((filtros) => ({
      ...filtros,
      pageSize: newPageSize,
      pagina: 1
    }))
    setSearching(true)
  }

  const fetchImages = useCallback(async () => {
    try {
      const res = await getImagenes(
        {
          ...filtros,
          publicadoDesde: filtros?.publicadoDesde?.format('YYYY-MM-DD') || null,
          publicadoHasta: filtros?.publicadoHasta?.format('YYYY-MM-DD') || null
        },
        tenant
      )
      setProductos(res.data.data)
      setPaginator({
        ...paginator,
        pageNumber: res.data.pageNumber,
        pageSize: res.data.pageSize,
        hasNextPage: res.data.hasNextPage,
        totalRecord: res.data.totalRecord
      })
    } catch (e) {
      console.log(e)
    } finally {
      setSearching(false)
    }
  }, [filtros, searching, tenant])

  const handleSincronizar = useCallback(() => {
    if (!filtros?.codLocal && !filtros?.codRubro && !filtros?.nombreProducto)
      return SnackBarUtils.info('Filtrá por local, rubro o producto para sincronizar imagenes')
    const filtrosAplicados = [
      filtros?.nombreRubro && `Rubro "${filtros.nombreRubro}"`,
      filtros?.nombreLocal && `Local "${filtros.nombreLocal}"`,
      filtros?.nombreProducto && `Producto "${filtros.nombreProducto}"`,
      filtros?.soloActivos && 'productos activos'
    ]
      .filter(Boolean)
      .join(', ')
    setConfirmDialog({
      open: true,
      text: {
        title: 'Se procesarán todas las fotos pendientes que coincidan con los filtros actuales',
        body: <>{`${filtrosAplicados || 'Sin filtros específicos'}. ¿Desea continuar?`}</>,
        leftButton: 'Cancelar',
        rightButton: 'Confirmar',
        colorButtonConfirm: 'error'
      },
      action: async () => {
        try {
          setLoading(true)
          const res = await sincronizar(
            tenant,
            1000,
            0,
            0,
            modelo,
            filtros?.codRubro,
            filtros?.codLocal,
            filtros?.soloActivos || false
          )
          res.data.data = SnackBarUtils.success(res.data.data)
          fetchImages()
        } catch (e) {
          console.log(e)
          SnackBarUtils.error(
            e.message === 'Network Error' || !e.message ? 'Ocurrió un error al sincronizar imágenes' : e.message
          )
        } finally {
          setLoading(false)
          clearConfirmDialog()
        }
      },
      close: () => clearConfirmDialog()
    })
  }, [filtros, tenant, modelo])

  const sincronizarFotos = useCallback(
    async (limit: number, idFoto: number, idProducto: number) => {
      const buttonKey = idFoto > 0 ? `caption-foto-${idFoto}` : `caption-producto-${idProducto}`
      try {
        setLoadingButtons((prev) => ({ ...prev, [buttonKey]: true }))
        const post = await sincronizar(tenant, limit, idFoto, idProducto, modelo)
        post.data.data && SnackBarUtils.success(post.data.data)
        fetchImages()
      } catch (e) {
        console.log(e)
        SnackBarUtils.error(e.message === 'Network Error' || !e.message ? 'Ocurrió un error al sincronizar' : e.message)
      } finally {
        setLoadingButtons((prev) => ({ ...prev, [buttonKey]: false }))
      }
    },
    [tenant, fetchImages, modelo]
  )

  const eliminarCaptions = useCallback(
    (idFoto: number, idProducto: number) => {
      const buttonKey = idFoto > 0 ? `eliminar-foto-${idFoto}` : `eliminar-producto-${idProducto}`

      setConfirmDialog({
        open: true,
        text: {
          title:
            idFoto === 0
              ? 'Se eliminarán las captions de todas las fotos del producto'
              : 'Se eliminará la caption de la imagen',
          body: '¿Desea continuar?',
          leftButton: 'Cancelar',
          rightButton: 'Confirmar',
          colorButtonConfirm: 'error'
        },
        action: async () => {
          try {
            setLoadingButtons((prev) => ({ ...prev, [buttonKey]: true }))
            const post = await deleteCaptions(tenant, idFoto, idProducto)
            post.data.data && SnackBarUtils.success(post.data.data)
            fetchImages()
          } catch (e) {
            console.log(e)
            SnackBarUtils.error(
              e.message === 'Network Error' || !e.message ? 'Ocurrió un error al eliminar' : e.message
            )
          } finally {
            setLoadingButtons((prev) => ({ ...prev, [buttonKey]: false }))
            clearConfirmDialog()
          }
        },
        close: () => clearConfirmDialog()
      })
    },
    [tenant, fetchImages]
  )

  // Función para contar fotos por estado
  const contarFotosPorEstado = (fotos: FotosProducto[]) => {
    const contadores = {
      pendiente: 0,
      caption: 0,
      error: 0
    }

    fotos.forEach((foto) => {
      if (foto.estado === 'pendiente') contadores.pendiente++
      else if (foto.estado === 'caption') contadores.caption++
      else if (foto.estado === 'error') contadores.error++
    })

    return contadores
  }

  useEffect(() => {
    if (searching) fetchImages()
  }, [searching])
  return (
    <>
      <Navbar title="Buscador de imágenes" />
      <Header>
        <FiltrosImagenes
          loading={loading}
          filtros={filtros}
          setFiltros={setFiltros}
          modelo={modelo}
          setModelo={setModelo}
          searching={searching}
          setSearching={setSearching}
          tenant={tenant}
          handleSincronizar={handleSincronizar}
        />
      </Header>
      {isMobile ? (
        <FotosMobile
          items={productos || []}
          paginator={paginator}
          contadorEstado={contarFotosPorEstado}
          loading={loading}
          loadingButtons={loadingButtons}
          sincronizarFotos={sincronizarFotos}
          eliminarCaptions={eliminarCaptions}
        />
      ) : (
        <FotosDesktop
          items={productos || []}
          paginator={paginator}
          contadorEstado={contarFotosPorEstado}
          loading={loading}
          loadingButtons={loadingButtons}
          sincronizarFotos={sincronizarFotos}
          eliminarCaptions={eliminarCaptions}
        />
      )}
      <Footer />
      <ConfirmDialog {...confirmDialog} />
    </>
  )
}

const mapStateToProps = (state: any) => {
  return {
    logged: state.logged,
    theme: state.theme,
    toaster: state.toaster,
    redirection: state.redirection
  }
}

const mapDispatchToProps = {
  setRedirectUrl,
  setLogged
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminProductosImagenes)
